import React from "react";
import AppLoading from "@/components/AppLoading";
import useAuth from "@/hooks/useAuth";

export default function LoginCallback() {
  const auth = useAuth();

  React.useLayoutEffect(() => {
    auth.handleLoginCallback();
  }, [auth]);

  return <AppLoading />;
}
